import { render, staticRenderFns } from "./Pinned_share.vue?vue&type=template&id=63aca5b8"
import script from "./Pinned_share.vue?vue&type=script&lang=js"
export * from "./Pinned_share.vue?vue&type=script&lang=js"
import style0 from "./Pinned_share.vue?vue&type=style&index=0&id=63aca5b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports